import React, { useCallback } from 'react';
import { Control } from '../Control';
import withField from '../withField';
import { clsm } from 'js/utils/classNames.util';
import { useTranslations } from 'js/hooks/i18n';
import ValidationIcon from '../Icons/ValidationIcon';
import { TextareaShallow } from './components/TextareaShallow';

import style from './Textarea.scss';

export const TextareaBare = ({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    id,
    name,
    hint,
    label,
    onClick,
    classNames = {},
    className = '',
    placeholder = '',
    showMaxLengthHint,
    autoResize = false,

    rows = 5,
    maxLength,
    readOnly,
    onMouseDown,

    ...textareaDomProps
}) => {
    const translate = useTranslations();
    const { active, touched, error, submitting } = meta;
    const bottomHint = showMaxLengthHint && maxLength
        ? `${maxLength - input.value?.length} ${translate('playtech.mobile.system.textarea.length.hint')}`
        : '';
    const onChange = useCallback((event) => {
        if (maxLength && event.target.value.length > maxLength) {
            return;
        }

        input.onChange?.(event);
    }, [input, maxLength]);
    const preventClick = useCallback(event => event.preventDefault(), []);
    const controlClassNames = clsm([style, classNames], ['content', 'bottomHint', 'control']);

    return (
        <Control
            id={id}
            meta={meta}
            hint={hint}
            label={label}
            animate={true}
            onClick={onClick}
            className={className}
            bottomHint={bottomHint}
            classNames={controlClassNames}
        >
            <TextareaShallow
                id={id}
                name={name}
                rows={rows}
                readOnly={readOnly}
                placeholder={placeholder}
                tabIndex={readOnly ? -1 : 0}
                maxLength={maxLength}
                autoResize={autoResize}
                aria-label={textareaDomProps['aria-label'] || translate('playtech.mobile.system.textarea.aria-label')}
                {...input}
                {...textareaDomProps}
                {...submitting ? { disabled: true } : {}}
                onChange={onChange}
                onMouseDown={readOnly ? preventClick : onMouseDown}
            />

            {touched && !active && (
                <ValidationIcon
                    animate={true}
                    isValid={!error}
                    aria-label={error}
                    tabIndex={error ? 0 : -1}
                    className={classNames?.validationIcon}
                />
            )}
        </Control>
    );
};

export const Textarea = withField(TextareaBare);
